import { Select } from '@/components/ui';
import {
  DM_OPTIONS,
  PROFILE_VIS_OPTIONS,
  type DmAudience,
  type ProfileVisibility,
  type TabProps,
} from '../../settings';
import { Field, SettingsCard, TRANSLUCENT_FIELD } from '../SettingsPrimitives';

export function PrivacyTab({ draft, set }: TabProps) {
  return (
    <SettingsCard title="Data & Privacy" desc="Control who can see and reach you.">
      <div>
        <Field label="Who can DM you?">
          <Select
            value={draft.privDMs}
            onChange={(e) => set('privDMs', e.target.value as DmAudience)}
            className={TRANSLUCENT_FIELD}
          >
            {DM_OPTIONS.map((o) => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </Select>
        </Field>

        <Field label="Profile visibility">
          <Select
            value={draft.privProfile}
            onChange={(e) => set('privProfile', e.target.value as ProfileVisibility)}
            className={TRANSLUCENT_FIELD}
          >
            {PROFILE_VIS_OPTIONS.map((o) => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </Select>
        </Field>
      </div>
    </SettingsCard>
  );
}
